import getTextualScale from "./getTextualScale";
import getLikertScale from "./getLikertScale";

function revert(array) {
  return array.slice().reverse();
}

/**
 * Get the scale array for the question, number , likert or inverted
 * @param {min_scale} minScale
 * @param {max_scale} maxScale
 * @param {inverted_scale} reverse
 * @param {scale_type} scaleType
 * @param {the type of the question item} questionType
 */
export default function getScale(minScale, maxScale, reverse, scaleType, questionType, language) {
  let scaleArray = [];
  if (!scaleType) {
    for (let i = minScale; i <= maxScale; i++) {
      scaleArray.push(i);
    }
    if (reverse) {
      scaleArray = revert(scaleArray);
    }
  } else if (scaleType === 2) {
    scaleArray = getTextualScale(maxScale, language);
  } else {
    scaleArray = getLikertScale(questionType, maxScale, language);
  }

  return scaleArray;
}
